import { createContext } from 'react'
import { TLoaderContext } from './types'

export default createContext<TLoaderContext>(null as any)
